module.exports = "<div class=\"footer\">\n    <div class=\"pull-right\">\n\n    </div>\n    <div>\n        <strong>Copyright</strong> Synergy Merchants Inc.\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/footer/footer.template.html
// module id = 1392
// module chunks = 9